export const reveneu = {
  no: 'No',
  store: '店舗',
  period: '期間',
  unit_no: '号機',
  latest_transactions: '最新取引',
  sales_information: '売上情報',
  number_sheet: '枚数',
  amount: '金額',
  total_sales: '総売上',
  pieces: '枚',
  yen: '円',
  tax_amount: '税額',
  payment_category: '支払い区分',
  cash: '現金',
  credit_card: 'クレジットカード',
  electronic_money: '電子マネー',
  barcode: 'バーコード',
  by_menu: 'メニュー別',
  by_group: 'グループ別',
  tab_by_time: '時間帯別',
  menu_number: 'メニュー番号',
  menu_name: 'メニュー名称',
  unit_price: '単価',
  group_name: 'グループ名称',
  group_time: '時間帯',
  header_popup_export: 'エクスポート用のメモ',
  start_date_within_one_year: "開始日付時刻から1年以内の範囲を指定してください。",
  start_date_before_end_date: "開始日は終了日より前の日付を指定してください。"
};
